import { useEffect } from 'react';
import { appConfig } from '../../../utils/appConfig';

declare global {
	interface Window {
		gtag: any;
		dataLayer: any;
		google_tag_manager: any;
	}
}

interface EventParams {
	item_title?: string;
	error?: string;
	source?: string;
	count?: number;
}

export const useGoogleAnalytics = () => {
	useEffect(() => {
		if (!window.google_tag_manager) {
			const script = document.createElement('script');
			script.src = `https://www.googletagmanager.com/gtag/js?id=${appConfig.googleAnalyticsId}`;
			script.async = true;
			document.body.appendChild(script);

			window.dataLayer = window.dataLayer || [];
			window.gtag = function () {
				window.dataLayer.push(arguments);
			};
			window.gtag('js', new Date());
			window.gtag('config', appConfig.googleAnalyticsId);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const logGoogleAnalyticsEvent = (eventName: string, eventParams?: EventParams) => {
		window.gtag('event', eventName, eventParams);
	};

	return [logGoogleAnalyticsEvent];
};
